import { jsxs, jsx } from "react/jsx-runtime";
const IconSocialInstagramSvg = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    fill: "currentColor",
    width: 16,
    height: 16,
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx("path", { d: "M7.858 2.07c-1.064.05-1.79.22-2.425.469-.658.256-1.215.6-1.77 1.156a4.9 4.9 0 0 0-1.15 1.773c-.246.637-.413 1.364-.46 2.429-.046 1.066-.057 1.407-.052 4.122.005 2.715.017 3.056.068 4.123.051 1.064.22 1.79.47 2.426.256.657.6 1.214 1.156 1.769a4.904 4.904 0 0 0 1.774 1.15c.636.245 1.363.413 2.428.46 1.066.047 1.407.057 4.122.052 2.716-.005 3.056-.017 4.123-.068 1.064-.05 1.79-.221 2.426-.47a4.901 4.901 0 0 0 1.769-1.156 4.903 4.903 0 0 0 1.15-1.774c.245-.636.413-1.363.46-2.427.046-1.067.057-1.408.052-4.123-.005-2.716-.018-3.056-.068-4.122-.05-1.065-.221-1.79-.47-2.427a4.905 4.905 0 0 0-1.156-1.769 4.894 4.894 0 0 0-1.774-1.15c-.636-.245-1.363-.413-2.427-.46-1.067-.047-1.407-.057-4.123-.052-2.715.005-3.056.017-4.123.068m.117 18.078c-.975-.043-1.504-.205-1.857-.34a3.136 3.136 0 0 1-1.152-.746 3.107 3.107 0 0 1-.75-1.149c-.137-.352-.302-.881-.347-1.856-.05-1.054-.061-1.37-.066-4.04-.005-2.67.004-2.986.05-4.041.042-.974.205-1.504.34-1.857.182-.468.398-.8.747-1.151.35-.351.682-.568 1.148-.75.353-.138.881-.302 1.856-.348 1.055-.05 1.37-.06 4.04-.066 2.67-.005 2.986.004 4.041.05.975.043 1.505.204 1.857.34.467.182.8.397 1.151.747.35.35.568.681.75 1.149.138.351.302.88.348 1.855.05 1.054.062 1.37.066 4.04.006 2.67-.004 2.986-.05 4.04-.043.976-.205 1.505-.34 1.859-.181.467-.398.8-.747 1.15a3.11 3.11 0 0 1-1.148.75c-.352.138-.882.302-1.856.349-1.054.05-1.37.06-4.04.065-2.67.006-2.986-.005-4.04-.05m8.151-13.492a1.2 1.2 0 1 0 2.4-.006 1.2 1.2 0 0 0-2.4.006M6.865 12.01a5.134 5.134 0 1 0 10.269-.02 5.134 5.134 0 0 0-10.269.02m1.802-.004a3.333 3.333 0 1 1 6.666-.011 3.333 3.333 0 0 1-6.666.011" })
    ]
  }
);
export {
  IconSocialInstagramSvg
};
